import Button from "../Buttons/Button"
import atencion from '../../assets/img/atencion.png'
import ResponsiveContainer from "../../layouts/ResponsiveContainer"

const CTASubscription = () => {
    return (
        <div className="h-[3.5rem] md:h-[3.375rem] bg-system-light-40 flex items-center justify-center">
            <ResponsiveContainer className="flex items-center gap-4  justify-center">
                <img src={atencion} alt="atención" className="w-[1.875rem] md:w-[2.875rem] h-[1.5rem] md:h-[2.375rem]" />
                <p className="text-bmedium text-primary-100">Recibí nuestros informes y novedades</p>
                <Button
                    showIconLeft={false}
                    showIconRight={false}
                    label="Suscribite"
                    className="!h-[1.75rem]"
                    variant="primary"
                    onClick={() => {
                        document.getElementById('subscription')?.scrollIntoView({
                            behavior: 'smooth'
                        });
                    }}
                />
            </ResponsiveContainer>
        </div>
    )
}

export default CTASubscription